// Rastreia a altura do teclado virtual (mobile) via a API `visualViewport` e
// expõe como a CSS custom property `--app-kb-height` em :root.
//
// Por que existe: quando o teclado abre no celular, ele sobrepõe o conteúdo
// — no iOS sempre; no Android quando o viewport não está em
// `interactive-widget=resizes-content`. Isso escondia a lista de autocomplete
// do Google Places atrás do teclado ao digitar um endereço.
//
// Os modais (`.settings-modal`) somam essa var no `padding-bottom`, então o
// card sobe pra área visível acima do teclado — junto com o input e o
// dropdown de sugestões.
//
// Compõe certo com `interactive-widget=resizes-content`: nesse modo o próprio
// layout viewport encolhe, `window.innerHeight` diminui junto, e a conta
// abaixo dá ~0 — sem subir o modal duas vezes.

let _installed = false;

export function ensureKeyboardInsetTracking() {
  if (_installed) return;
  _installed = true;

  const vv = typeof window !== 'undefined' ? window.visualViewport : null;
  if (!vv) return;   // navegador sem suporte — a var fica no default (0px)

  const root = document.documentElement;

  const update = () => {
    // Altura do teclado ≈ o que sobra entre o layout viewport e a área que o
    // visualViewport realmente mostra. Clamp em ≥ 0; sobras pequenas (< 90px)
    // são ignoradas — a barra de endereço do browser também mexe no
    // visualViewport e não queremos confundir com o teclado.
    const overlap = window.innerHeight - vv.height - vv.offsetTop;
    const kb = overlap > 90 ? Math.round(overlap) : 0;
    root.style.setProperty('--app-kb-height', kb + 'px');
  };

  vv.addEventListener('resize', update);
  vv.addEventListener('scroll', update);
  update();
}
